import React, { useState, useEffect } from "react";
import cn from "classnames";

import Modal from "components/Modal";

interface IProps {
  options: Array<any>;
}

const Slider: React.SFC<IProps> = ({ options }) => {
  const [modal, setShowModal] = useState<number | undefined>(undefined);
  const hideModal = () => setShowModal(undefined);

  useEffect(() => {
    return setBigPhoto(0);
  },
  [options]);
  const [bigPhoto, setBigPhoto] = useState(0);


  const handleChangeArrow = (photoIndex: number, side: string) => {
    let position = 0;
    {
      options.map(
        (value:string, index: number) =>{
          index === photoIndex &&
          (side === "left" ? (position = index - 1) : (position = index + 1));
        }

      );
    }
    if (position > options.length - 1) {
      position = 0;
    } else if (position < 0) {
      position = options.length - 1;
    }

    setBigPhoto(position);
  };

  const handleChange = (index: number, photoIndex: number) => {
    let position = 0;
    position = index;
    setBigPhoto(position);
  };

  return (
    <React.Fragment>
    <div className="product d-block d-md-flex d-lg-block">
      <div className="product__img text-center">
        <div
          className="product__prev"
          onClick={() => handleChangeArrow(bigPhoto, "left")}
        >
          <svg
            width="12"
            height="20"
            viewBox="0 0 12 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.777329 10.7293C0.356276 10.3343 0.356275 9.66575 0.777328 9.27072L10.3158 0.321788C10.9544 -0.277318 12 0.175456 12 1.05107L12 18.9489C12 19.8245 10.9544 20.2773 10.3158 19.6782L0.777329 10.7293Z"
              fill="#E6ECEE"
            />
          </svg>
        </div>
        <div className="compress">
          <img src={options[bigPhoto]} alt="" onClick={() => setShowModal(1)} />
        </div>
        <div
          className="product__next"
          onClick={() => handleChangeArrow(bigPhoto, "right")}
        >
          <svg
            width="12"
            height="20"
            viewBox="0 0 12 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.2227 9.27072C11.6437 9.66574 11.6437 10.3343 11.2227 10.7293L1.68421 19.6782C1.04564 20.2773 3.6263e-07 19.8245 3.85304e-07 18.9489L8.48771e-07 1.05107C8.71446e-07 0.175454 1.04564 -0.27732 1.68421 0.321786L11.2227 9.27072Z"
              fill="#E6ECEE"
            />
          </svg>
        </div>
      </div>
      <div className=" d-flex justify-content-center justify-content-lg-between row ml-lg-1 lk slider-photo-all">
        {options.map((value: any, index: number) => (
          <div
            className={cn("product__mini text-center", {'img-opacity': index === bigPhoto})}
            key={`item-${index}`}
            onClick={() => handleChange(index, bigPhoto)}
          >
            <img src={value} alt="" />
          </div>
        ))}
      </div>
    </div>
    {modal && (
        <Modal onClose={hideModal} id="sliderModal">
         <div
            className="product__prev"
            onClick={() => handleChangeArrow(bigPhoto, "left")}
          >
            <svg
              width="12"
              height="20"
              viewBox="0 0 12 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.777329 10.7293C0.356276 10.3343 0.356275 9.66575 0.777328 9.27072L10.3158 0.321788C10.9544 -0.277318 12 0.175456 12 1.05107L12 18.9489C12 19.8245 10.9544 20.2773 10.3158 19.6782L0.777329 10.7293Z"
                fill="#E6ECEE"
              />
            </svg>
          </div>
          <img src={options[bigPhoto]} />
          <div
            className="product__next"
            onClick={() => handleChangeArrow(bigPhoto, "right")}
          >
            <svg
              width="12"
              height="20"
              viewBox="0 0 12 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.2227 9.27072C11.6437 9.66574 11.6437 10.3343 11.2227 10.7293L1.68421 19.6782C1.04564 20.2773 3.6263e-07 19.8245 3.85304e-07 18.9489L8.48771e-07 1.05107C8.71446e-07 0.175454 1.04564 -0.27732 1.68421 0.321786L11.2227 9.27072Z"
                fill="#E6ECEE"
              />
            </svg>
          </div>
          {/* <a onClick={hideModal} className="reg__clean">Отмена</a> */}
        </Modal>
      )}
    </React.Fragment>
  );
};

export default Slider;
